import { FC } from 'react'
import styled from 'styled-components'
import { SlideButton } from './slideButton'

const Container = styled.div`
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    justify-self: center;
    user-select: none;
    position: relative;
    display: flex;
    justify-content: center;
`

const SelectedImage = styled.img`
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    user-select: none;
`

const Next = styled.div`
    position: absolute;
    top: 50%;
    right: 1.5em;
`

const Previous = styled.div`
    position: absolute;
    top: 50%;
    left: 1.5em;
`

interface Props {
    selectedImageUrl: string
    onNext: () => void
    onPrevious: () => void
}

export const SlideContent: FC<Props> = ({
    selectedImageUrl,
    onNext,
    onPrevious,
}) => {
    return (
        <Container>
            <SelectedImage src={selectedImageUrl} />
            <Next>
                <SlideButton
                    slideDirection="next"
                    onClick={() => {
                        onNext()
                    }}
                />
            </Next>
            <Previous>
                <SlideButton
                    slideDirection="previous"
                    onClick={() => {
                        onPrevious()
                    }}
                />
            </Previous>
        </Container>
    )
}
